import { render, staticRenderFns } from "./ReadMoreModal.vue?vue&type=template&id=5953fa02&scoped=true&"
import script from "./ReadMoreModal.vue?vue&type=script&lang=js&"
export * from "./ReadMoreModal.vue?vue&type=script&lang=js&"
import style0 from "./ReadMoreModal.vue?vue&type=style&index=0&id=5953fa02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953fa02",
  null
  
)

export default component.exports